function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import { textConvertToMultiLine } from "../../../utils";
import styles from './Heading.scss';

var Heading = function Heading(_ref) {
  var _classnames;

  var level = _ref.level,
      children = _ref.children,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'text' : _ref$color,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === void 0 ? false : _ref$wrap,
      _ref$multiLine = _ref.multiLine,
      multiLine = _ref$multiLine === void 0 ? false : _ref$multiLine,
      className = _ref.className;
  var Tag = "h".concat(level);
  return /*#__PURE__*/React.createElement(Tag, {
    className: classnames([styles["heading--h".concat(level)]], className, (_classnames = {}, _defineProperty(_classnames, styles["heading-color--".concat(String(color))], color !== 'text'), _defineProperty(_classnames, styles['heading--inline'], inline), _defineProperty(_classnames, styles['heading--wrap'], wrap), _classnames))
  }, multiLine ? textConvertToMultiLine(children) : children);
};

export default Heading;